import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8e9842a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "clinic-daily-routine main-content-wrapper" }

import Form from "./components/common/form.vue";
import { set, get } from "@vueuse/core";
import { ref, onBeforeMount, inject } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const clinicId = ref(0);

onBeforeMount(async () => {
  console.log("onBeforeMount");
  await set(clinicId, await inject("clinicId"));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (clinicId.value)
      ? (_openBlock(), _createBlock(Form, {
          key: 0,
          clinicId: _unref(get)(clinicId.value)
        }, null, 8, ["clinicId"]))
      : _createCommentVNode("", true)
  ]))
}
}

})